export default __webpack_public_path__ + "static/media/logo.bd1df348.png";